class ColourSwatches extends HTMLElement {
  constructor() {
      super();

      this.container = this.querySelector('.colour-swatches__container');

      if (this.classList.contains("locked")) {
          return;
      }

      this.setSettings().then(settings => {
          var self = this;

          this.classList.add('locked');

          if (settings == null) {
              this.classList.remove('locked');
              throw 'Empty settings!';
          }

          const collection = "all";//settings.currentCollection ? settings.currentCollection : "all";
          if (settings.groupTag && settings.groupTag != "undefined") {
              var url = `${window.routes.collections_url}/${collection}/${encodeURIComponent(settings.groupTag)}?view=json`

          } else {
              var url = `${window.routes.root_url}products/${encodeURIComponent(settings.handle)}?view=json`
          }

          fetch(url).then((response) => response.json())
              .then((responseJson) => {
                  self.container.classList.add("loaded");
                  if (!Array.isArray(responseJson)) {
                      responseJson = responseJson.products;
                  }
                  if (responseJson.length <= 1) {
                      self.classList.add("hidden");
                      self.nextElementSibling?.classList.remove("hidden");
                  } else {
                    if (window.location.href.search("/products") === -1) {
                      self.nextElementSibling?.classList.add("hidden");
                    }
                    self.initSwatches(responseJson, settings);
                    self.initMainImages(responseJson, settings);
                  }
                  
                  self.classList.remove('locked');
                });
    })
        .catch((e) => { console.log(e)});
  }
  
  setSettings() {
      var self = this;
    
      var promise = new Promise(function(resolve, reject) {
      var interval = setInterval(function(){
        const settingsRawJson = self.querySelector("#swatches-settings");
        if(!settingsRawJson) return {}
          if (settingsRawJson.innerHTML != "") {
          clearInterval(interval);
            // console.log('resolve');
          resolve(JSON.parse(settingsRawJson.innerHTML));
        }
        }, 100)
      window.setTimeout(function() {
        clearInterval(interval);

        resolve(null);
      }, 3000);
    });
    
    return promise;
  }
  
  initMainImages(products, settings) {
    
    let images = document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}'] .new-swatch-images`);
    if (images) return;
    
      var html = "";

    products.forEach(product => {
      let variant = product.variants[0];
        html += `<img 
          data-variant-id="${variant.id}"
          data-sizes="auto" 
          src="${variant.featured_image?.src}"
          data-src="${variant.featured_image?.src}"
          alt="${variant.title}" 
          class="fade-in new-swatch-images" />`
    });
    
    let mainImage = document.querySelectorAll(`.product-grid-item__image[data-product-id='${settings.id}'] img`)[0];
    
    if (mainImage) {
      mainImage.classList.remove('blur-up');
      mainImage.classList.remove('fade-in');
    }
    
    if (document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`)) {
      document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`).innerHTML += html;
    }
  }
  initSwatches(products, settings) {
    var html = "";
    let moreSwatchesCount = 0;
    const maxVisibleSwatches = 20; // Maximum number of visible swatches
    const gridItemDetails = this.closest('.product-grid-item__details');
    const isInsideDetails = gridItemDetails !== null;
    const variantSwatches = gridItemDetails ? gridItemDetails.querySelector('.product-variant-swatches') : null;

    products.forEach((product, index) => {
      const variant = product.variants[0];
      const img = this.getProductImage(product, settings);

      let isSelectedClass = '';
  
      if (settings.handle === product.handle) {
        isSelectedClass = 'selected';
      }
  
      if (variantSwatches) {
        variantSwatches.classList.add("hidden");
      }
  
      product.hasNullPrice = product.price === 0;
  
      const el = `<div class="product-grid-item__swatch-container--new product-grid-item__swatch-container--new-plp ${isSelectedClass} thumbnail" 
                      data-product-id="${product.id}" 
                      data-variant-id="${variant.id}" 
                      data-hasnullprice="${product.hasNullPrice}" 
                      data-available="${product.available}" 
                      data-image="${product.second_image}"
                      data-handle="${product.handle}">
                    <span class="swatch-circle">${img}</span>
                  </div>`;
  
      if (isInsideDetails) {
        if (index < maxVisibleSwatches) {
          html += el;
        } else {
          moreSwatchesCount++;
        }
      } else {
        html += el;
      }
    });
  
    if (html) {
      this.container.innerHTML = html;
  
      const swatches = this.container.querySelectorAll('.product-grid-item__swatch-container--new');
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          const productId = swatch.dataset.productId;
          const variantId = swatch.dataset.variantId;
  
          const mainImageContainer = document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`);
          if (mainImageContainer) {
            const newImage = mainImageContainer.querySelector(`img[data-variant-id='${variantId}']`);
            if (newImage) {
              mainImageContainer.querySelectorAll('.new-swatch-images').forEach((img) => img.classList.remove('selected'));
              newImage.classList.add('selected');
            }
          }
  
          swatches.forEach((item) => item.classList.remove('selected'));
          swatch.classList.add('selected');
        });
      });
    }
  }
  

  getProductImage(product, settings) {
    var imageSrc = product.featured_image;

    switch (settings.image_type) {
      case "image_swatch":
        const colourTag = product.tags.find(tag => tag.indexOf(settings.colourTagPrefix) > -1);
        if(colourTag) {
          const colour = colourTag.replace(settings.colourTagPrefix, "").toLowerCase();
          imageSrc = "https:" + settings.swatchUrl.replace("swatch", `colour-${colour}`);
        }
        break;
      case "first_variant_image":
        const firstVariantImage = product.variants[0].image;
        if(firstVariantImage) imageSrc = firstVariantImage;
        break;
      case "last_variant_image":
        const lastVariantImg = product.variants[product.variants.length - 1].image;
        if(lastVariantImg) imageSrc = lastVariantImg;
        break;
      default:
        break;
    }

    return `<img src="${imageSrc}" data-image="${product.second_image}" width="40" alt=""/>`;
  }


}
customElements.define('colour-swatches', ColourSwatches);

class ColourSwatchesProduct extends HTMLElement {
  constructor() {
      super();

      this.container = this.querySelector('.colour-swatches__container');

      if (this.classList.contains("locked")) {
          return;
      }

      this.setSettings().then(settings => {
          var self = this;

          this.classList.add('locked');

          if (settings == null) {
              this.classList.remove('locked');
              throw 'Empty settings!';
          }

          const collection = "all";//settings.currentCollection ? settings.currentCollection : "all";
          if (settings.groupTag && settings.groupTag != "undefined") {
              var url = `${window.routes.collections_url}/${collection}/${encodeURIComponent(settings.groupTag)}?view=json`

          } else {
              var url = `${window.routes.root_url}products/${encodeURIComponent(settings.handle)}?view=json`
          }

          fetch(url).then((response) => response.json())
              .then((responseJson) => {
                  self.container.classList.add("loaded");
                  if (!Array.isArray(responseJson)) {
                      responseJson = responseJson.products;
                  }
                  if (responseJson.length <= 1) {
                      self.classList.add("hidden");
                      self.nextElementSibling.classList.remove("hidden");
                  } else {
                      if (window.location.href.search("/products") == -1) {
                          self.nextElementSibling.classList.add("hidden");
                      }
                      self.initSwatches(responseJson, settings);
                      self.initMainImages(responseJson, settings);
                      self.setCurrent(self);
                  }

                  self.classList.remove('locked');
              });
      })
      .catch((e) => { console.log(e)});
  }

  setSettings() {
      var self = this;

      var promise = new Promise(function(resolve, reject) {
        var interval = setInterval(function(){
              const settingsRawJson = self.querySelector("#swatches-settings");
          if(!settingsRawJson) return {}
              if (settingsRawJson.innerHTML != "") {
                  clearInterval(interval);
                  resolve(JSON.parse(settingsRawJson.innerHTML));
              }
          }, 100)
        window.setTimeout(function() {
              clearInterval(interval);
              resolve(null);
          }, 3000);
      });

      return promise;
  }

  initMainImages(products, settings) {

      let images = document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}'] .new-swatch-images`);
      if (images) return;

      var html = "";

      products.forEach(product => {
          let variant = product.variants[0];
          html += `<img 
      data-variant-id="${variant.id}"
      data-sizes="auto" 
      src="${variant.featured_image.src}"
      data-src="${variant.featured_image.src}"
      alt="${variant.title}" 
      class="fade-in new-swatch-images" />`
      });

      let mainImage = document.querySelectorAll(`.product-grid-item__image[data-product-id='${settings.id}'] img`)[0];

      if (mainImage) {
          mainImage.classList.remove('blur-up');
          mainImage.classList.remove('fade-in');
      }

      if (document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`)) {
          document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`).innerHTML += html;
      }
  }

  initSwatches(products, settings) {
      var html = "";
      products.forEach(product => {
          const variant = product.variants[0];
          const img = this.getProductImage(product, settings);
          product.hasNullPrice = false;
          if (product.price == 0) {
              product.hasNullPrice = true;
          }
          const el = `<a class="product-grid-item__swatch-container--new" data-product-id="${product.id}" data-variant-id="${variant.id}" data-hasnullprice=${product.hasNullPrice} data-available="${product.available}" data-handle="${product.handle}" href="${product.url}">${img}</a>`;
          html += el
      })
      if(html)  this.container.innerHTML = html
  }

  getProductImage(product, settings) {
      var imageSrc = product.featured_image;
      switch (settings.image_type) {
          case "image_swatch":
              const colourTag = product.tags.find(tag => tag.indexOf(settings.colourTagPrefix) > -1);
          if(colourTag) {
                  const colour = colourTag.replace(settings.colourTagPrefix, "").toLowerCase();
                  imageSrc = "https:" + settings.swatchUrl.replace("swatch", `colour-${colour}`);
              }
              break;
          case "first_variant_image":
              const firstVariantImage = product.variants[0].image;
          if(firstVariantImage) imageSrc = firstVariantImage;
              break;
          case "last_variant_image":
              const lastVariantImg = product.variants[product.variants.length - 1].image;
          if(lastVariantImg) imageSrc = lastVariantImg;
              break;
          default:
              break;
      }
      const image = `<img src="${imageSrc}">`;
      return image;
  }

  setCurrent(self) {
      if (window.current.product.handle != '') {
          self.container.querySelector(`[data-handle="${window.current.product.handle}"]`).classList.add("selected");
          self.container.querySelector(`[data-handle="${window.current.product.handle}"]`).classList.add("selected");
      }
  }
}
customElements.define('colour-swatches-product', ColourSwatchesProduct);


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
          mouseClick = false;
      }
  });

  window.addEventListener('mousedown', (event) => {
      mouseClick = true;
  });

  window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');

  }, true);
}

function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class MembershipPrice extends HTMLElement {
  constructor() {
      super()
  }

  connectedCallback() {
      const url = `/products/${this.dataset.productHandle}`
      this.getProductSection(url)
  }

  getProductSection(url) {
      fetch(`${url}?sections=product`)
          .then(res => res.json())
          .then(data => this.renderSection(data.product))
  }

  renderSection(str) {
      const parser = new DOMParser();
      const docApi = parser.parseFromString(str, 'text/html');
      const wrapper = this.closest('.product-grid-item-wrapper')

      const memberSection = docApi.querySelector('div.membership-price-badge')
      this.innerHTML = memberSection.innerHTML

      if (this.querySelector('a')) {
        this.querySelector('a').classList.add('hide')
      }

      if (!memberSection.classList.contains('hidden')) {
          this.classList.remove('hidden')
          wrapper.classList.add('member-price')
      }
  }
}
customElements.define('membership-price', MembershipPrice)

class PricePlp extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const url = `/products/${this.dataset.productHandle}`
    this.getProductSection(url)
  }

  getProductSection(url) {
    fetch(`${url}?sections=product`)
    .then(res => res.json())
    .then(data => this.renderSection(data.product))
  }

  renderSection(str) {
    const parser = new DOMParser();
    const docApi = parser.parseFromString(str, 'text/html');

    const priceSection = docApi.querySelector('.price-container__price-wrapper')
    if (priceSection && priceSection.querySelector('[data-compare-price]')) {
      this.innerHTML = priceSection.innerHTML
    }
  }
}
customElements.define('price-card', PricePlp)